/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/self-closing-comp */
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { ReactComponent as Person } from '../../../images/person-gray-r.svg';
import { ReactComponent as Meal } from '../../../images/meal-r.svg';
import './css/HotLoader.css';

function HotLoader() {
  return (
    <div className="hot_item_w">
      <div>
        <div className="hot_hotel_img_w hot_loader_image mb_10">
          <Skeleton height="220px" width="290px" borderRadius="16px" />
        </div>
        <div className="hot_i_hotel_name">
          <Skeleton height="22px" width="200px" />
        </div>
        <div className="hot_i_hotel_text mb_17">
          <Skeleton height="18px" width="160px" />
        </div>
      </div>
      <div>
        <div className="hot_tour_i_info_w">
          <div className="hot_i_tourists_w">
            <Person className="hot_i_person_ico" />
            <Skeleton height="18px" width="120px" />
          </div>
          <div className="hot_i_meal_w">
            <Meal className="hot_i_meal_ico" />
            <Skeleton height="18px" width="90px" />
          </div>
        </div>
        <div className="hot_i_price_w">
          <Skeleton height="48px" width="170px" borderRadius="12px" />
        </div>
      </div>
    </div>
  );
}

export default HotLoader;
